import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IPlenum {
  plenumID: number;
  name: string;
  numberConnections: number;
  maxFlowRate: number;
  canSupply: boolean;
  canExtraction: boolean;
  ductID: number;
  imageID: number;
}

export const getPlenums = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/Plenum', config);
  return response.data;
};
